<template>
  <div class="box" v-loading="loading">
    <div class="table_wrap">
      <div class="count_box">
        <div class="count">
          {{ language("orderRecord.results") }}: {{ results }}
          {{ language("orderRecord.rows") }}
        </div>
        <div class="page_wrap">
          <page :total="results" @pageChange="pageChange"></page>
        </div>
      </div>
      <cc-table
        :loadData="false"
        :config="table"
        :params="params"
        :dataArr="dataArr"
        :refeshParams="refeshTable"
        :emptyText="language('productsRecord.emptyText')"
        :showIndex="false"
      ></cc-table>
    </div>
  </div>
</template>
<script>
import page from "../../../components/page";

export default {
  components: {
    page,
  },
  props: {
    viewData: Object,
  },
  data() {
    return {
      loading: true,
      dataArr: [],
      results: 0,
      params: {},
      refeshTable: -1,
      table: {
        api: "",
        showPager: false,
        columns: [
          {
            prop: "mchNum",
            lable: "Master A/C",
            minWidth: 130,
          },
          // {
          //   prop: "Master ID",
          //   lable: "Master ID",
          // },
          {
            prop: "masterOrderId",
            lable: "Master Order ID",
            minWidth: 150,
          },
          {
            prop: "orderId",
            lable: "Order ID",
            minWidth: 180,
          },
          {
            prop: "orderStatusName",
            lable: "Order Status",
            minWidth: 140,
          },
          {
            prop: "transactionStatusName",
            lable: "Transaction Status",
            minWidth: 140,
          },
          {
            prop: "orderTime",
            lable: "Order Create",
            minWidth: 200,
          },
          {
            prop: "updateTime",
            lable: "Updated Time",
            minWidth: 200,
          },
          {
            prop: "deliveredDate",
            lable: "Delivered Date",
            minWidth: 200,
          },
          {
            prop: "productId",
            minWidth: 160,
            lable: "Product ID",
          },
          {
            prop: "productName",
            minWidth: 200,
            lable: "Product Name",
          },
          {
            prop: "saleNum",
            lable: "QTY",
            minWidth: 100,
          },
          {
            prop: "originalPrice",
            lable: "Original Sales Amount",
            minWidth: 100,
            render: (rows) => {
              return rows.originalPriceF;
            },
          },
          {
            prop: "netSaleAmount",
            lable: "Net Sales Amount",
            minWidth: 100,
            render: (rows) => {
              return rows.netSaleAmountF;
            },
          },
          {
            prop: "refundPrice",
            lable: "Refund Amount",
            minWidth: 100,
            render: (rows) => {
              return rows.refundPriceF;
            },
          },
          {
            prop: "actualPrice",
            lable: "Actual Sales",
            minWidth: 100,
            render: (rows) => {
              return rows.actualPriceF;
            },
          },
          {
            prop: "promotionId",
            lable: "Promotion ID",
            minWidth: 200,
          },
          {
            prop: "promotionType",
            lable: "Promotion Type",
            minWidth: 100,
          },
        ],
        buttons: [],
      },
      form: {
        pageSize: 10,
        pageNo: 1,
      },
    };
  },
  methods: {
    getData(e) {
      this.ccRequest
        .do("admin/merchant/report/getOrderRecord", e)
        .then((res) => {
          this.dataArr = res.rows;
          this.results = res.total;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;

          this.$message.error(err.response.data.message);
        });
    },
    pageChange(e) {
      this.form.pageSize = e.pageSize;
      this.form.pageNo = e.pageNo;
      this.form.orderId = this.viewData.orderId;
      this.getData(this.form);
    },
  },
  mounted() {
    this.form.orderId = this.viewData.orderId;

    this.getData(this.form);
  },
};
</script>
<style scoped lang="scss">
.box {
  height: 100%;
}

.button_wrap {
  margin-top: 20px;
}
.table_wrap {
  .count {
    font-size: $sbuTitle;
    margin-bottom: 20px;
    font-weight: 600;
  }
}
.button_wrap {
  margin-bottom: 20px;
}
.table_wrap {
  .count {
    font-size: $sbuTitle;
    font-weight: 600;
  }
  .count_box {
    margin-bottom: 20px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>